<p-confirmDialog
  [style]="style()"
  [styleClass]="styleClass()"
  [dismissableMask]="dismissableMask()"
  [maskStyleClass]="maskStyleClass()"
  [closeAriaLabel]="closeAriaLabel()"
  [acceptAriaLabel]="acceptAriaLabel()"
  [rejectAriaLabel]="rejectAriaLabel()"
  [appendTo]="appendTo()"
  [autoZIndex]="autoZIndex()"
  [baseZIndex]="baseZIndex()"
  [transitionOptions]="transitionOptions()"
  [focusTrap]="focusTrap()"
  [breakpoints]="breakpoints()"
  [draggable]="draggable()"
  [defaultFocus]="defaultFocus()"
/>
